/* eslint-disable */
import React, {Component} from "react";
import {ANALYSTPREP_LOGO, ROLES} from "../../common/constant";
import {isStringEmpty, testEmptyString} from "../../utils/CommonUtils";

export class AppLogo extends Component{

    static defaultProps = {
        userRole: null,
        organizationLogo: null,
    }

    state = {
        logoUrl: ANALYSTPREP_LOGO,
        logoClassNames: null
    }

    constructor(props, context) {
        super(props, context);
    }

    _checkLogoAvailability(logoUrl){
       return new Promise((resolve, reject) => {
           if(logoUrl == null || isStringEmpty(logoUrl)){
               reject('Logo url is null or empty');
               return;
           }
           const img = new Image();
           img.src = logoUrl;
           img.onload = () => {
               this.setState({logoUrl: logoUrl});
               img.remove();
               resolve(true);
           }
           img.onerror = (e) => {
               console.warn(`Error loading logo image: ${e.target.src}`);
               img.remove();
               resolve(false);
           }
       })
    }

    async componentWillReceiveProps(nextProps, nextContext) {
        try {
            const logoAvailable = await this._checkLogoAvailability(nextProps.organizationLogo);
            if(logoAvailable && nextProps.userRole != null && nextProps.userRole === ROLES.PARTNER){
                this.setState({logoClassNames: ['circular-logo']});
            }
        }catch (e) {
            // console.log("Logo check error: ", e);
        }
    }

    getClassNames(){
        if(this.state.logoClassNames != null && this.state.logoClassNames.constructor === Array && this.state.logoClassNames.length > 0){
            return this.state.logoClassNames.join(' ');
        }
        return null;
    }

    render() {
        return (
            <a
                className='navbar-brand header-logo-section'
                href='#'
                id='header-logo-section'
                aria-label='AnalystPrep home'
            >
                <img
                    src={this.state.logoUrl}
                    className={this.getClassNames()}
                    alt='Logo'
                />
            </a>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Header/AppLogo.jsx